import { TruncatedAccount } from "@narmi/design_system";
import filters from "byzantine/src/filters";
import { catcat as cc } from "cerulean";
import logoStyles from "../../../PreviewCard/Logo.module.scss";
import { getRecipientById } from "./BulkPaymentTable";
import styles from "./BulkPaymentTable.module.scss";

type SelectedRecipientCardType = {
  recipientId: API.RecipientId;
  rowIndex: number;
  form?: any;
  recipients: API.Recipient[];
  recipient?: API.Recipient;
  handleClickEditRecipient?: (
    recipientId: API.RecipientId,
    rowIndex?: number
  ) => void;
  handleClickUnsavedRecipient?: (recipient: API.Recipient, rowIndex: number) => void;
  staticCard?: boolean;
};

const SelectedRecipientCard = ({
  recipientId,
  rowIndex,
  form,
  recipients,
  recipient: fallbackRecipient,
  handleClickEditRecipient,
  handleClickUnsavedRecipient,
  staticCard,
}: SelectedRecipientCardType) => {
  const storeRecipient = getRecipientById(recipients, recipientId);
  const recipient = storeRecipient ?? fallbackRecipient;
  if (!recipient) return null;

  // The recipients list only contains non-hidden recipients, so if we
  // found the recipient there it is definitely saved.  Fall back to the
  // form-state object's `hidden` flag only when the store doesn't have it.
  const isUnsaved = !storeRecipient && recipient.hidden === true;
  const nameClickable = isUnsaved && handleClickUnsavedRecipient;

  return (
    <div
      className={cc(styles.selectedRecipientCardContainer, {
        [styles.interactive]: !staticCard,
      })}
    >
      <div className={styles.nameContainer}>
        <span
          className={
            (cc("fontSize--m fontWeight--normal"), styles.nameEllipsis)
          }
          onClick={
            nameClickable
              ? () => handleClickUnsavedRecipient(recipient, rowIndex)
              : undefined
          }
          style={
            nameClickable
              ? { cursor: "pointer" }
              : undefined
          }
        >
          {" "}
          {recipient.name}
        </span>
        <div className={styles.institutionNameContainer}>
          <div className={logoStyles.logo}>
            <span className="narmi-icon-bank" />
          </div>
          <span className="fontColor--secondary fontSize--xs">
            <TruncatedAccount
              lastFour={
                recipient.ach_destination?.account_number?.slice(-4) ?? ""
              }
              name={filters.capitalizeFirstLetter(
                recipient.ach_destination?.account_type ?? ""
              )}
            />
          </span>
        </div>
      </div>
      <div className={styles.iconsContainer}>
        {!staticCard && handleClickEditRecipient ? (
          <>
            <span
              className="narmi-icon-edit margin--right--xs"
              onClick={() => {
                if (isUnsaved && handleClickUnsavedRecipient) {
                  handleClickUnsavedRecipient(recipient, rowIndex);
                } else {
                  handleClickEditRecipient(recipientId);
                }
              }}
            />
            <span
              className="narmi-icon-x"
              onClick={() => {
                form.setFieldValue(
                  `payments.${rowIndex}.recipient`,
                  undefined
                );
                form.setFieldValue(
                  `payments.${rowIndex}.speedStatus`,
                  ""
                );
                form.setFieldValue(
                  `payments.${rowIndex}.speedStatusWithExpediteOption`,
                  ""
                );
              }}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default SelectedRecipientCard;
